import styled from "styled-components";

const ResponsiveContainer = styled.div`
  padding-right: 25px;
  padding-left: 25px;
  margin-right: auto;
`;

export default ResponsiveContainer;
